// src/components/ProtectedRoute.js
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

const ProtectedRoute = ({ children, requiredRole, requiredPermission }) => {
  const { token, user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <Loader2 className="h-8 w-8 animate-spin text-indigo-600" />
      </div>
    );
  }

  if (!token) {
    return <Navigate to="/login" />;
  }

  // Verificar rol
  if (requiredRole && user?.role !== requiredRole) {
    return <Navigate to="/" />;
  }

  // Verificar permisos
  if (requiredPermission && !user?.permissions.includes(requiredPermission)) {
    return <Navigate to="/" />;
  }

  return children;
};

export default ProtectedRoute;
